import instance from "./instance";
import { ENV } from "@/constants/env";
import {
  PromptTemplateDto,
  CreatePromptTemplateDto,
  UpdatePromptTemplateDto,
  PromptTemplateListRequestDto,
} from "@/dto/PromptTemplateDto";
import { ResultListDto, ResponseDto } from "@/dto/ResponseDto";

const PREFIX_PATH = `${ENV.PRE_FIX}/${ENV.ADMIN_PATH}`;

export const promptTemplateApi = {
  async getList(
    params: PromptTemplateListRequestDto = {}
  ): Promise<ResultListDto<PromptTemplateDto>> {
    const apiUrl = `${PREFIX_PATH}/prompt-template`;
    const response = await instance.get(apiUrl, { params });
    return response;
  },

  async getCategories(): Promise<string[]> {
    const apiUrl = `${PREFIX_PATH}/prompt-template/categories`;
    const response = await instance.get<ResponseDto<string[]>>(apiUrl);
    if (!response.success || !response.data) {
      throw new Error(response.message || "Failed to fetch categories");
    }
    return response.data;
  },

  async getDetail(id: number): Promise<PromptTemplateDto> {
    const apiUrl = `${PREFIX_PATH}/prompt-template/${id}`;
    const response = await instance.get<ResponseDto<PromptTemplateDto>>(apiUrl);
    if (!response.success || !response.data) {
      throw new Error(response.message || "Prompt template not found");
    }
    return response.data;
  },

  async create(data: CreatePromptTemplateDto): Promise<PromptTemplateDto> {
    const apiUrl = `${PREFIX_PATH}/prompt-template`;
    const response = await instance.post<ResponseDto<PromptTemplateDto>>(apiUrl, data);
    if (!response.success || !response.data) {
      throw new Error(response.message || "Failed to create prompt template");
    }
    return response.data;
  },

  async update(id: number, data: UpdatePromptTemplateDto): Promise<PromptTemplateDto> {
    const apiUrl = `${PREFIX_PATH}/prompt-template/${id}`;
    const response = await instance.put<ResponseDto<PromptTemplateDto>>(apiUrl, data);
    if (!response.success || !response.data) {
      throw new Error(response.message || "Failed to update prompt template");
    }
    return response.data;
  },

  async delete(id: number): Promise<void> {
    const apiUrl = `${PREFIX_PATH}/prompt-template/${id}`;
    const response = await instance.delete<ResponseDto<null>>(apiUrl);
    if (!response.success) {
      throw new Error(response.message || "Failed to delete prompt template");
    }
  },
};